<template>
  <span class="highlight-text">
    <slot></slot>
  </span>
</template>

<style lang="scss" scoped>
.highlight-text {
  color: #ffdd0c;
}
</style>
